<script setup lang="ts">
import { REVIEWS } from "./shared";
import DotCarousel from "../../common/DotCarousel/index.vue";
import ReviewItem from "./ReviewItem.vue";
import background from "../../../../images/reviews-background.png";
</script>

<template>
    <section class="w-full flex flex-col pt-20">
        <div class="w-full flex gap-9 flex-col px-16 pb-10 relative overflow-hidden">
            <h2 class="font-bold font-mulish text-40 leading-120 text-custom-black gap-9 relative z-[1]">
            Trusted by Compliance Leaders
        </h2>
        <DotCarousel class="relative z-[1]" :items-length="REVIEWS.length">
            <ReviewItem v-for="review in REVIEWS" :key="review.id" :review="review" />
        </DotCarousel>
        <img :src="background" alt="" class="absolute top-0 bottom-0 right-0 z-0 pointer-events-none h-full max-w-[60%] object-contain object-right-bottom" />
        </div>
    </section>
</template>
